import React from 'react'
import errorArt from '../../assets/404.png'

function index() {
  return (
    <div>
      <img src={errorArt} alt='' />
    </div>
  )
}

export default index